export default __webpack_public_path__ + "static/media/book.d2584b62.svg";